// Service Worker Registration Utility

type ServiceWorkerConfig = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onOffline?: () => void;
  onOnline?: () => void;
};

export function register(config?: ServiceWorkerConfig): void {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      registerValidSW(swUrl, config);

      // Handle online/offline events
      window.addEventListener('online', () => {
        console.log('[SW] App is online');
        config?.onOnline?.();
      });

      window.addEventListener('offline', () => {
        console.log('[SW] App is offline');
        config?.onOffline?.();
      });
    });
  }
}

function registerValidSW(swUrl: string, config?: ServiceWorkerConfig): void {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[SW] Service Worker registered:', registration.scope);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available; notify user
              console.log('[SW] New content available; please refresh.');
              config?.onUpdate?.(registration);
            } else {
              // Content is cached for offline use
              console.log('[SW] Content is cached for offline use.');
              config?.onSuccess?.(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[SW] Error during service worker registration:', error);
    });
}

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[SW] Error during service worker unregistration:', error);
      });
  }
}

// Utility to check if running as installed PWA
export function isRunningAsPWA(): boolean {
  // Check display mode
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

  // Check iOS standalone mode
  const isIOSStandalone = (window.navigator as any).standalone === true;

  // Check if launched from home screen
  const isLaunchedFromHomeScreen =
    document.referrer.includes('android-app://') ||
    (window as any).matchMedia?.('(display-mode: standalone)')?.matches;

  return isStandalone || isIOSStandalone || isLaunchedFromHomeScreen;
}

// Utility to prompt for PWA installation
export function canInstallPWA(): boolean {
  return !isRunningAsPWA() && 'BeforeInstallPromptEvent' in window;
}
